import React, { useEffect, useRef } from 'react';
import { ProductDetailsProps } from '@customTypes/product-details';
import IndividualBilledProductDetails from './IndividualBilledProductDetails';
import GroupedBilledProductDetails from './GroupedBilledProductDetails';
import TimeSlotProductDetails from './TimeSlotProductDetails';

function ProductDetailsCardFactory(props: ProductDetailsProps) {
  const firstRender = useRef(true);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
    }
  }, []);

  const { product } = props;
  // ex: Time Slotted
  if (product.is_product_time_group) {
    return <TimeSlotProductDetails {...props} />;
  }

  switch (product.individual_billing) {
    // ex: Day Passes
    case true:
      return <IndividualBilledProductDetails {...props} />;

    // ex: Cabanas
    default:
      return <GroupedBilledProductDetails {...props} />;
  }
}

export default ProductDetailsCardFactory;
